import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NdgInsertComponent } from './ndg-insert.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTableModule } from 'src/app/data-table/data-table.module';

@NgModule({
  declarations: [
    NdgInsertComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FontAwesomeModule,
    AppRoutingModule,

    FormsModule,
    ReactiveFormsModule,

    DataTableModule
  ]
})
export class NdgInsertModule { }
